import React from "react"
import { useDispatch } from "react-redux"

import { setUserId } from "../../../redux/inscription"
import { IUserCustom } from "../../../interfaces/user.custom"

interface IProps {
  user: IUserCustom
}

const AddUserTd = ({ user }: IProps) => {
  const dispatch = useDispatch()
  const { firstName, lastName, email, userId, registered } = user

  return (
    <tr>
      <td>{firstName}</td>
      <td>{lastName}</td>
      <td>{email}</td>
      <td>
        <button
          type="button"
          className={`button ${!registered && "is-primary"}`}
          disabled={registered}
          onClick={() => userId && dispatch(setUserId(userId))}
          style={{ width: "100%" }}
        >
          {registered
            ? "Cette personne est inscrite"
            : "Inscrire cette personne"}
        </button>
      </td>
    </tr>
  )
}

export default AddUserTd
